module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "text-white px-4 pt-5 flex items-center justify-between relative"
  }, [_c('a', {
    attrs: {
      "id": "toggle-nav"
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_c('i', {
    staticClass: "inline-block h-8 w-8 mask mask-menu bg-white"
  }), _vm._v(" "), _c('span'), _vm._v(" "), (_vm.badgeCount > 0) ? _c('div', {
    staticClass: "indicator"
  }, [_c('div', {
    staticClass: "noti_count",
    attrs: {
      "role": "status"
    }
  }, [_vm._v(_vm._s(_vm.badgeCount))])]) : _vm._e()]), _vm._v(" "), (_vm.$route.name === 'home') ? _c('span', [_c('img', {
    staticClass: "h-14",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "Fi360"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'home' && _vm.$route.name !== 'support') ? _c('h1', {
    staticClass: "flex items-center gap-2 mb-5"
  }, [_c('i', {
    staticClass: "inline-block",
    class: _vm.iconHeaderClass
  }), _vm._v(" "), _c('span', {
    staticClass: "whitespace-nowrap"
  }, [_vm._t("default")], 2)]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'support') ? _c('h1', {
    staticClass: "flex items-center gap-2 mb-5"
  }, [_c('span', {
    staticClass: "whitespace-nowrap"
  }, [_vm._t("default")], 2)]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'home') ? _c('notif-bar') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72cca980","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = 1040
// module chunks = 0